import React from "react";
import SampleDrivingLicensePopup from "./SampleDrivingLicense";

export interface ISampleDLMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}

// Mobile uses the same centred modal (single column, internal scroll) as
// desktop instead of a bottom sheet.
const SampleSDLMobileViewProps = (props: ISampleDLMobileViewProps) => (
  <SampleDrivingLicensePopup showPopup={props.showPopup} setShowPopup={props.setShowPopup} />
);
export default SampleSDLMobileViewProps;
